import React, { Component } from "react";
import LoadingView from "presentational/common/LoadingView";
import PropTypes from "prop-types";

const Z_INDEX_FOR_MODAL = 1400; // 모달이 1300

class LoadingModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onModal: PropTypes.bool
  };

  static defaultProps = {
    onModal: false
  };

  getCss() {
    const { onModal } = this.props;
    return {
      wrapper: {
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "white",
        opacity: 0.8,
        display: "flex",
        alignItems: "center",
        zIndex: onModal ? Z_INDEX_FOR_MODAL : 100
      }
    };
  }

  render() {
    const { open } = this.props;
    const css = this.getCss();

    return (
      <div>
        {open && (
          <div style={css.wrapper}>
            <LoadingView sizePX={60} />
          </div>
        )}
      </div>
    );
  }
}

export default LoadingModalView;
